import Support from '.';
import { IRoute } from '../../utils/navigation/routes';
import Incidents from './incidents';
import IncidentDetail from './incidents/incidentDetail';
import IncidentsFeedback from './incidentsFeedback';
import SolveIncident from './solveIncident';

export const problemsRoutes: IRoute[] = [
    { path: '/support', element: <Support /> },
    { path: '/support/solve-incident', element: <SolveIncident /> },
    { path: '/support/incidents', element: <Incidents /> },
    { path: '/support/incidents/incident-detail/:problemId', element: <IncidentDetail /> },
    { path: '/support/incidents-feedback', element: <IncidentsFeedback /> },
];
